import React, { useState, useCallback } from 'react'
import { Navbar, Sidebar, SidebarExpanded } from './components'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { DashboardIcon } from '~/assets/icons'
import { SidebarItem } from './types'

const useStyles = makeStyles({
  content: {
    [mutualTheme.breakpoints.up('md')]: {
      marginLeft: mutualTheme.sidebar.minimizedWidthMdUp
    },
    display: 'flex',
    flexDirection: 'column',
    minHeight: `calc(100vh - ${mutualTheme.topbar.height}px)`
  }
})

export const Layout: React.FC = (props) => {
  const classes = useStyles()
  const { children } = props
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen(prevState => {
      return !prevState
    })
  }, [])

  const sidebarItems: SidebarItem[] = [
    { icon: <DashboardIcon htmlColor={!isSidebarOpen ? mutualTheme.palette.common.white : mutualTheme.palette.secondary.main} />, path: '/app/loan-request', label: 'Visão geral' }
  ]

  return (
    <>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar items={sidebarItems} />
      <SidebarExpanded isOpen={isSidebarOpen} onClose={toggleSidebar} items={sidebarItems} />
      <main className={classes.content}>
        {children}
      </main>
    </>
  )
}
